/*
 * Elcokids - Load More robust (Divas Web Design, oct 2026)
 * ---------------------------------------------------------------------------
 * Inlocuieste cele doua scripturi vechi din theme.liquid
 * ("loadmore-state" din <head> si "Fix scroll Back" de la final).
 *
 * Ce rezolva:
 *  1. Dupa Back din pagina de produs (sau cand browserul de pe mobil
 *     reincarca tab-ul dupa o perioada / din lipsa de memorie), pagina
 *     revenea la primele 20 de produse. Acum starea (cate pagini au fost
 *     incarcate + produsul la care era utilizatorul) se salveaza in
 *     history.state (legat de intrarea din istoric) + sessionStorage ca
 *     rezerva, iar la revenire paginile se reincarca in paralel si pagina
 *     se pozitioneaza pe produsul la care era utilizatorul.
 *  2. Dublu-tap / click repetat pe "Load more" lansa 2 cereri pentru aceeasi
 *     pagina (componenta nu verifica "disabled") -> produse duplicate si
 *     numaratoare gresita. Acum exista un singur request activ per sectiune.
 *  3. Butoanele desktop si mobil (ambele randate in DOM) se desincronizau:
 *     doar cel apasat isi actualiza URL-ul. Acum ambele sunt sincronizate.
 *  4. Se foloseste Section Rendering API (?section_id=) -> raspuns mult mai
 *     mic decat pagina intreaga, deci incarcare mai rapida si mai putina
 *     memorie consumata pe mobil.
 */
(function () {
  'use strict';

  if (window.__elcoLoadMoreInit) return;
  window.__elcoLoadMoreInit = true;

  var STATE_KEY = 'elcoLM';
  var SS_PREFIX = 'elcoLM:';
  var MAX_RESTORE_PAGES = 40;          // limita de siguranta (~800 produse)
  var MAX_AGE_MS = 2 * 60 * 60 * 1000; // starea din sessionStorage expira dupa 2h
  var FETCH_CONCURRENCY = 4;
  var TRACKING_PARAMS = /^(utm_|_ga|_gl|fbclid|gclid|gbraid|wbraid|srsltid|_pos|_sid|_ss|_psq|_fid|mc_|_kx)/i;

  /* ----------------------------------------------------------------- utils */

  function pageKey() {
    var params = new URLSearchParams(location.search);
    var clean = [];
    params.forEach(function (value, key) {
      if (TRACKING_PARAMS.test(key)) return;
      clean.push([key, value]);
    });
    clean.sort(function (a, b) { return a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0; });
    var qs = clean.map(function (p) {
      return encodeURIComponent(p[0]) + '=' + encodeURIComponent(p[1]);
    }).join('&');
    return location.pathname + (qs ? '?' + qs : '');
  }

  function navigationType() {
    try {
      var nav = performance.getEntriesByType('navigation');
      if (nav && nav.length && nav[0].type) return nav[0].type;
    } catch (e) {}
    try {
      if (performance.navigation) {
        if (performance.navigation.type === 2) return 'back_forward';
        if (performance.navigation.type === 1) return 'reload';
      }
    } catch (e) {}
    return 'navigate';
  }

  function toAbsUrl(url) {
    return new URL(url, location.origin);
  }

  function pageFromUrl(url) {
    try {
      var p = parseInt(toAbsUrl(url).searchParams.get('page') || '1', 10);
      return isNaN(p) || p < 1 ? 1 : p;
    } catch (e) {
      return 1;
    }
  }

  function withPage(url, page) {
    var u = toAbsUrl(url);
    u.searchParams.set('page', String(page));
    u.searchParams.delete('section_id');
    return u.pathname + u.search;
  }

  function cleanPaginationUrl(url) {
    if (!url) return url;
    try {
      var u = toAbsUrl(url);
      u.searchParams.delete('section_id');
      if (!u.searchParams.has('_ajax')) u.searchParams.set('_ajax', '1');
      return u.pathname + u.search;
    } catch (e) {
      return url;
    }
  }

  /* ----------------------------------------------------------------- state */

  var memoryState = null;
  var lastReplace = 0;
  var replaceTimer = null;

  function readState() {
    var key = pageKey();
    try {
      var hs = history.state && history.state[STATE_KEY];
      if (hs && hs.key === key && hs.page > 1) return hs;
    } catch (e) {}

    // Rezerva: doar la Back/Forward sau reload, niciodata la o navigare noua
    // (ex. click din meniu pe categorie -> trebuie sa porneasca de sus).
    var type = navigationType();
    if (type !== 'back_forward' && type !== 'reload') return null;
    try {
      var raw = sessionStorage.getItem(SS_PREFIX + key);
      if (!raw) return null;
      var ss = JSON.parse(raw);
      if (ss && ss.key === key && ss.page > 1 && Date.now() - (ss.t || 0) < MAX_AGE_MS) return ss;
    } catch (e) {}
    return null;
  }

  function commitHistoryState() {
    replaceTimer = null;
    lastReplace = Date.now();
    if (!memoryState) return;
    try {
      var merged = Object.assign({}, history.state || {});
      merged[STATE_KEY] = memoryState;
      history.replaceState(merged, '');
    } catch (e) {
      // Safari limiteaza replaceState (100 apeluri / 30s) - ignoram.
    }
  }

  function saveState(patch, immediate) {
    memoryState = Object.assign({ key: pageKey(), page: 1 }, memoryState || {}, patch || {});
    memoryState.key = pageKey();
    memoryState.t = Date.now();

    try {
      sessionStorage.setItem(SS_PREFIX + memoryState.key, JSON.stringify(memoryState));
    } catch (e) {}

    if (immediate) {
      if (replaceTimer) clearTimeout(replaceTimer);
      commitHistoryState();
      return;
    }
    if (replaceTimer) return;
    var wait = Math.max(0, 1000 - (Date.now() - lastReplace));
    replaceTimer = setTimeout(commitHistoryState, wait);
  }

  function setManualScrollRestoration() {
    try {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    } catch (e) {}
  }

  /* --------------------------------------------------------------- context */

  function getContext(fromEl) {
    var comp = fromEl && fromEl.closest ? fromEl.closest('pagination-component') : null;
    if (!comp) return null;
    var containerId = comp.dataset.containerId;
    var target = comp.dataset.target;
    var container = containerId ? document.getElementById(containerId) : null;
    if (!container || !target) return null;

    var section = comp.closest('.shopify-section');
    var sectionId = null;
    if (section && section.id && section.id.indexOf('shopify-section-') === 0) {
      sectionId = section.id.slice('shopify-section-'.length);
    }
    var scope = section || document;
    var comps = Array.prototype.filter.call(
      scope.querySelectorAll('pagination-component'),
      function (c) { return c.dataset.containerId === containerId; }
    );

    return {
      section: section,
      lockEl: section || container,
      sectionId: sectionId,
      containerId: containerId,
      container: container,
      target: target,
      comps: comps
    };
  }

  function getItems(ctx) {
    return Array.prototype.filter.call(
      ctx.container.querySelectorAll('.' + ctx.target),
      function (el) { return el.parentNode === ctx.container; }
    );
  }

  function productKeyOf(item) {
    // Cheia e memorata pe element, pentru ca un card "adormit" nu mai are
    // continut in DOM.
    if (item.dataset && item.dataset.elcoKey) return item.dataset.elcoKey;
    var a = item.querySelector('a[href*="/products/"]');
    if (!a) return null;
    try {
      var k = toAbsUrl(a.getAttribute('href')).pathname;
      if (item.dataset) item.dataset.elcoKey = k;
      return k;
    } catch (e) { return null; }
  }

  function setLoading(ctx, isLoading) {
    ctx.comps.forEach(function (c) {
      var btn = c.querySelector('pagination-load-button');
      if (!btn) return;
      btn.toggleAttribute('disabled', isLoading);
      btn.classList.toggle('loading', isLoading);
    });
  }

  /* ----------------------------------------------------------------- fetch */

  function parseDoc(text) {
    return new DOMParser().parseFromString(text, 'text/html');
  }

  function fetchDoc(ctx, url) {
    var full = toAbsUrl(url);
    full.searchParams.delete('section_id');

    var sectionUrl = null;
    if (ctx.sectionId) {
      var su = toAbsUrl(full.href);
      su.searchParams.set('section_id', ctx.sectionId);
      sectionUrl = su.pathname + su.search;
    }

    function get(u) {
      return fetch(u, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      }).then(parseDoc);
    }

    var first = sectionUrl ? get(sectionUrl) : get(full.pathname + full.search);
    return first.then(function (doc) {
      if (doc.getElementById(ctx.containerId)) return doc;
      if (!sectionUrl) throw new Error('container missing');
      return get(full.pathname + full.search);
    }, function (err) {
      if (!sectionUrl) throw err;
      return get(full.pathname + full.search);
    });
  }

  function fetchAll(ctx, urls) {
    var results = new Array(urls.length);
    var index = 0;
    function worker() {
      if (index >= urls.length) return Promise.resolve();
      var i = index++;
      return fetchDoc(ctx, urls[i]).then(function (doc) {
        results[i] = doc;
      }, function () {
        results[i] = null;
      }).then(worker);
    }
    var workers = [];
    for (var w = 0; w < Math.min(FETCH_CONCURRENCY, urls.length); w++) workers.push(worker());
    return Promise.all(workers).then(function () { return results; });
  }

  /* ---------------------------------------------------------------- update */

  function appendItems(ctx, doc, focusFirst) {
    var newContainer = doc.getElementById(ctx.containerId);
    if (!newContainer) return 0;

    var existing = {};
    getItems(ctx).forEach(function (item) {
      var k = productKeyOf(item);
      if (k) existing[k] = true;
    });

    var newItems = Array.prototype.filter.call(
      newContainer.querySelectorAll('.' + ctx.target),
      function (el) { return el.parentNode === newContainer; }
    );

    var fragment = document.createDocumentFragment();
    var firstAdded = null;
    newItems.forEach(function (item) {
      var k = productKeyOf(item);
      if (k && existing[k]) return; // fara duplicate
      if (k) existing[k] = true;
      fragment.appendChild(document.adoptNode(item));
      if (!firstAdded) firstAdded = item;
    });
    ctx.container.appendChild(fragment);

    if (focusFirst && firstAdded) {
      var focusable = firstAdded.querySelector('a[href], button, [tabindex]');
      if (focusable) {
        try { focusable.focus({ preventScroll: true }); } catch (e) {}
      }
    }
    return newItems.length;
  }

  function syncPaginations(ctx, doc) {
    var scope = (ctx.section && doc.getElementById(ctx.section.id)) || doc;
    var newComps = Array.prototype.filter.call(
      scope.querySelectorAll('pagination-component'),
      function (c) { return c.dataset.containerId === ctx.containerId; }
    );

    ctx.comps.forEach(function (comp, i) {
      var fresh = newComps[i] || newComps[0];
      if (!fresh) {
        var oldBtn = comp.querySelector('pagination-load-button');
        if (oldBtn) oldBtn.remove();
        return;
      }
      Array.prototype.forEach.call(fresh.querySelectorAll('pagination-load-button[data-url]'), function (b) {
        b.setAttribute('data-url', cleanPaginationUrl(b.getAttribute('data-url')));
      });
      ['data-current', 'data-total', 'data-page-size'].forEach(function (attr) {
        if (fresh.hasAttribute(attr)) comp.setAttribute(attr, fresh.getAttribute(attr));
      });
      // Copie statica a listei INAINTE de adoptNode (childNodes e o lista "vie"
      // care se micsoreaza pe masura ce mutam nodurile).
      var nodes = Array.prototype.slice.call(fresh.childNodes).map(function (n) {
        return document.adoptNode(n);
      }).filter(function (n) { return n && n.nodeType; });
      comp.replaceChildren.apply(comp, nodes);
    });
  }

  function currentNextUrl(ctx) {
    for (var i = 0; i < ctx.comps.length; i++) {
      var b = ctx.comps[i].querySelector('pagination-load-button[data-url]');
      if (b && b.dataset.url) return b.dataset.url;
    }
    return null;
  }

  /* ------------------------------------------------------------ load more */

  function loadNext(btn) {
    var ctx = getContext(btn);
    if (!ctx) return Promise.resolve(false);

    // Un singur request activ per sectiune (dublu-tap, desktop+mobil etc.)
    if (ctx.lockEl.__elcoBusy) return ctx.lockEl.__elcoBusy;

    var url = btn.dataset.url || currentNextUrl(ctx);
    if (!url) return Promise.resolve(false);

    setLoading(ctx, true);
    var p = fetchDoc(ctx, url).then(function (doc) {
      // Daca intre timp s-a schimbat continutul (ex. filtru aplicat), ignoram.
      var still = currentNextUrl(ctx);
      if (still && cleanPaginationUrl(still) !== cleanPaginationUrl(url)) return false;

      appendItems(ctx, doc, true);
      syncPaginations(ctx, doc);
      setManualScrollRestoration();
      saveState({ page: pageFromUrl(url) }, true);
      return true;
    }).catch(function (err) {
      console.warn('[elco-load-more] eroare la incarcare', err);
      return false;
    }).then(function (res) {
      ctx.lockEl.__elcoBusy = null;
      var fresh = getContext(ctx.comps[0]) || ctx;
      setLoading(fresh, false);
      return res;
    });

    ctx.lockEl.__elcoBusy = p;
    return p;
  }

  function patchLoadButton() {
    if (!window.customElements) return;
    customElements.whenDefined('pagination-load-button').then(function () {
      var Cls = customElements.get('pagination-load-button');
      if (!Cls || !Cls.prototype || Cls.prototype.__elcoPatched) return;
      Cls.prototype.fetchResults = function () {
        return loadNext(this);
      };
      Cls.prototype.__elcoPatched = true;
    });
  }

  /* --------------------------------------------------------------- anchor */

  var userInteracted = false;

  function computeAnchor(ctx) {
    var items = getItems(ctx);
    for (var i = 0; i < items.length; i++) {
      var r = items[i].getBoundingClientRect();
      if (r.bottom > 0 && r.height > 0) {
        return { anchorIndex: i, anchorKey: productKeyOf(items[i]), anchorOffset: Math.round(r.top) };
      }
    }
    return null;
  }

  function scrollToAnchor(ctx, st) {
    if (!st || st.anchorIndex == null) return;
    var items = getItems(ctx);
    var el = null;
    if (st.anchorKey) {
      for (var i = 0; i < items.length; i++) {
        if (productKeyOf(items[i]) === st.anchorKey) { el = items[i]; break; }
      }
    }
    if (!el) el = items[Math.min(st.anchorIndex, items.length - 1)];
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - (st.anchorOffset || 0);
    window.scrollTo(0, Math.max(0, top));
  }

  function trackAnchor(ctx) {
    var t = null;
    function update(immediate) {
      if (!memoryState || memoryState.page <= 1) return;
      var a = computeAnchor(ctx);
      if (a) saveState(a, immediate);
    }
    window.addEventListener('scroll', function () {
      if (t) clearTimeout(t);
      t = setTimeout(function () { update(false); }, 200);
    }, { passive: true });

    // La click pe un produs: salvare imediata a pozitiei exacte.
    document.addEventListener('click', function (e) {
      var item = e.target && e.target.closest ? e.target.closest('.' + ctx.target) : null;
      if (!item || item.parentNode !== ctx.container) return;
      if (!memoryState || memoryState.page <= 1) return;
      var items = getItems(ctx);
      var idx = items.indexOf(item);
      if (idx < 0) return;
      saveState({
        anchorIndex: idx,
        anchorKey: productKeyOf(item),
        anchorOffset: Math.round(item.getBoundingClientRect().top)
      }, true);
    }, true);

    window.addEventListener('pagehide', function () { update(true); });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') update(true);
    });
  }

  /* -------------------------------------------------------------- restore */

  function restore(ctx, st) {
    var nextUrl = currentNextUrl(ctx);
    if (!nextUrl) {
      scrollToAnchor(ctx, st);
      return Promise.resolve();
    }
    var startPage = pageFromUrl(nextUrl);
    var endPage = Math.min(st.page, startPage + MAX_RESTORE_PAGES - 1);
    if (endPage < startPage) {
      scrollToAnchor(ctx, st);
      return Promise.resolve();
    }

    var urls = [];
    for (var p = startPage; p <= endPage; p++) urls.push(withPage(nextUrl, p));

    setLoading(ctx, true);
    var job = fetchAll(ctx, urls).then(function (docs) {
      var lastDoc = null;
      var lastPage = startPage - 1;
      for (var i = 0; i < docs.length; i++) {
        if (!docs[i]) break; // pastram ordinea: ne oprim la prima pagina esuata
        appendItems(ctx, docs[i], false);
        lastDoc = docs[i];
        lastPage = startPage + i;
      }
      if (lastDoc) {
        syncPaginations(ctx, lastDoc);
        ctx = getContext(ctx.comps[0]) || ctx;
      }
      memoryState = Object.assign({}, st, { page: Math.max(lastPage, 1) });
      saveState({}, true);

      var apply = function () { if (!userInteracted) scrollToAnchor(ctx, st); };
      apply();
      requestAnimationFrame(apply);
      setTimeout(apply, 350);
      setTimeout(apply, 1000);
      if (document.readyState !== 'complete') window.addEventListener('load', apply, { once: true });
    }).catch(function (err) {
      console.warn('[elco-load-more] restore esuat', err);
    }).then(function () {
      ctx.lockEl.__elcoBusy = null;
      setLoading(getContext(ctx.comps[0]) || ctx, false);
    });

    ctx.lockEl.__elcoBusy = job;
    return job;
  }

  /* --------------------------------------------------------------- memorie */
  /*
   * Pe iPhone (Safari si Chrome folosesc acelasi motor WebKit) pagina era
   * omorata de sistem dupa ~50-80 de produse: fiecare card tinea in memorie
   * pana la 5 poze din carusel la rezolutie mare. Rezultat: "refresh automat"
   * si apoi "Can't open this page".
   *  - pozele 2-5 din carusel au clasa "elco-deferred" (din Liquid) si se
   *    incarca doar cand clientul atinge caruselul;
   *  - cardurile aflate la peste ~2 ecrane distanta isi elibereaza pozele si
   *    le reiau automat inainte sa revina in ecran.
   */

  var BLANK_IMG = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
  var ITEM_SELECTOR = '.shop__grid-item';
  var sleepObserver = null;
  var observedItems = [];

  function wakeDeferred(root) {
    var imgs = root.querySelectorAll('img.elco-deferred');
    Array.prototype.forEach.call(imgs, function (img) {
      img.classList.remove('elco-deferred');
      img.classList.add('lazyload');
      try {
        if (window.lazySizes && window.lazySizes.loader && window.lazySizes.loader.unveil) {
          window.lazySizes.loader.unveil(img);
        }
      } catch (e) {}
    });
  }

  function sleepItem(item) {
    if (item.__elcoAsleep) return;
    item.__elcoAsleep = true;

    Array.prototype.forEach.call(item.querySelectorAll('img'), function (img) {
      // Doar pozele deja incarcate de lazysizes (sau fara lazy-load).
      if (img.classList.contains('lazyload') || img.classList.contains('lazyloading') ||
          img.classList.contains('elco-deferred')) return;
      var srcset = img.getAttribute('srcset');
      var src = img.getAttribute('src');
      if (!srcset && (!src || src === BLANK_IMG)) return;
      img.setAttribute('data-elco-src', src || '');
      if (srcset) {
        img.setAttribute('data-elco-srcset', srcset);
        img.removeAttribute('srcset');
      }
      img.setAttribute('src', BLANK_IMG);
    });

    Array.prototype.forEach.call(item.querySelectorAll('video'), function (video) {
      try { video.pause(); } catch (e) {}
      var touched = false;
      if (video.getAttribute('src')) {
        video.setAttribute('data-elco-src', video.getAttribute('src'));
        video.removeAttribute('src');
        touched = true;
      }
      Array.prototype.forEach.call(video.querySelectorAll('source[src]'), function (s) {
        s.setAttribute('data-elco-src', s.getAttribute('src'));
        s.removeAttribute('src');
        touched = true;
      });
      if (touched) {
        video.setAttribute('data-elco-video', '1');
        try { video.load(); } catch (e) {}
      }
    });

    Array.prototype.forEach.call(item.querySelectorAll('iframe[src]'), function (frame) {
      var src = frame.getAttribute('src');
      if (!src || src === 'about:blank') return;
      frame.setAttribute('data-elco-src', src);
      frame.setAttribute('src', 'about:blank');
    });

    // Scoatem continutul cardului din pagina (carusel, video, widget-uri),
    // pastrand un spatiu gol de aceeasi inaltime - pagina nu "sare".
    var h = item.getBoundingClientRect().height;
    if (h > 0 && item.firstChild) {
      item.style.height = Math.round(h) + 'px';
      var frag = document.createDocumentFragment();
      while (item.firstChild) frag.appendChild(item.firstChild);
      item.__elcoFrag = frag;
    }
  }

  function wakeItem(item) {
    if (!item.__elcoAsleep) return;
    item.__elcoAsleep = false;

    if (item.__elcoFrag) {
      item.appendChild(item.__elcoFrag);
      item.__elcoFrag = null;
      item.style.height = '';
    }

    Array.prototype.forEach.call(item.querySelectorAll('img[data-elco-src]'), function (img) {
      var srcset = img.getAttribute('data-elco-srcset');
      if (srcset) img.setAttribute('srcset', srcset);
      img.setAttribute('src', img.getAttribute('data-elco-src') || BLANK_IMG);
      img.removeAttribute('data-elco-srcset');
      img.removeAttribute('data-elco-src');
    });

    Array.prototype.forEach.call(item.querySelectorAll('video[data-elco-video]'), function (video) {
      if (video.getAttribute('data-elco-src')) {
        video.setAttribute('src', video.getAttribute('data-elco-src'));
        video.removeAttribute('data-elco-src');
      }
      Array.prototype.forEach.call(video.querySelectorAll('source[data-elco-src]'), function (s) {
        s.setAttribute('src', s.getAttribute('data-elco-src'));
        s.removeAttribute('data-elco-src');
      });
      video.removeAttribute('data-elco-video');
      try {
        video.load();
        if (video.autoplay || video.hasAttribute('autoplay')) {
          var pr = video.play();
          if (pr && pr.catch) pr.catch(function () {});
        }
      } catch (e) {}
    });

    Array.prototype.forEach.call(item.querySelectorAll('iframe[data-elco-src]'), function (frame) {
      frame.setAttribute('src', frame.getAttribute('data-elco-src'));
      frame.removeAttribute('data-elco-src');
    });
  }

  function observeItems(root) {
    if (!sleepObserver || !root) return;
    var list = [];
    if (root.nodeType === 1 && root.matches && root.matches(ITEM_SELECTOR)) list.push(root);
    if (root.querySelectorAll) {
      Array.prototype.push.apply(list, root.querySelectorAll(ITEM_SELECTOR));
    }
    if (!list.length) return;
    // Uitam cardurile vechi scoase din pagina (ex. dupa aplicarea unui filtru).
    observedItems = observedItems.filter(function (it) {
      if (it.isConnected) return true;
      sleepObserver.unobserve(it);
      return false;
    });
    list.forEach(function (item) {
      if (item.__elcoObserved) return;
      item.__elcoObserved = true;
      productKeyOf(item);
      observedItems.push(item);
      sleepObserver.observe(item);
    });
  }

  function initMemoryManager() {
    // Caruselul de pe card: pozele amanate se incarca la prima atingere.
    var wakeHandler = function (e) {
      var carousel = e.target && e.target.closest ? e.target.closest('.product-card__carousel') : null;
      if (carousel) wakeDeferred(carousel);
    };
    document.addEventListener('touchstart', wakeHandler, { passive: true, capture: true });
    document.addEventListener('pointerdown', wakeHandler, { passive: true, capture: true });

    if (!('IntersectionObserver' in window)) return;

    var margin = Math.max(1500, Math.round((window.innerHeight || 800) * 2.5));
    sleepObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) wakeItem(entry.target);
        else sleepItem(entry.target);
      });
    }, { root: null, rootMargin: margin + 'px 0px ' + margin + 'px 0px', threshold: 0 });

    observeItems(document);

    // La schimbarea latimii (rotire telefon) inaltimile cardurilor se schimba:
    // trezim tot si lasam observer-ul sa reevalueze.
    var lastWidth = window.innerWidth;
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (Math.abs(window.innerWidth - lastWidth) < 2) return;
      lastWidth = window.innerWidth;
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        observedItems = observedItems.filter(function (it) { return it.isConnected; });
        observedItems.forEach(function (it) {
          sleepObserver.unobserve(it);
          wakeItem(it);
          sleepObserver.observe(it);
        });
      }, 250);
    });

    // Produse noi (load more, filtre aplicate prin AJAX etc.)
    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            if (added[j].nodeType === 1) observeItems(added[j]);
          }
        }
      }).observe(document.body || document.documentElement, { childList: true, subtree: true });
    }
  }

  /* --------------------------------------------------------------- filtre */
  /*
   * Tema originala, la fiecare bifa de filtru pe mobil, descarca si parsa
   * pagina INTREAGA de 3 ori (updateShop + updateFilters + inca un
   * updateFilters), iar pe desktop de 2 ori. Mai multe filtre bifate rapid =
   * zeci de MB procesati simultan -> crash pe iPhone; in plus raspunsurile
   * puteau veni in ordine gresita.
   * Acum: o singura cerere per URL (partajata), doar sectiunea de produse
   * (Section Rendering API), cererea veche se anuleaza cand se bifeaza alt
   * filtru, iar raspunsurile depasite se ignora.
   */
  var SHOP_ELEMENTS = ['ShopProducts', 'ShopProductCount', 'ShopSortList', 'ShopActiveFilters'];
  var FILTER_SIDEBARS = '#SidebarFiltersMobile, #SidebarFiltersDesktop';

  function shopSectionId(shop) {
    var section = shop.closest ? shop.closest('.shopify-section') : null;
    if (section && section.id && section.id.indexOf('shopify-section-') === 0) {
      return section.id.slice('shopify-section-'.length);
    }
    return null;
  }

  function moveChildren(target, source) {
    var nodes = Array.prototype.slice.call(source.childNodes).map(function (n) {
      return document.adoptNode(n);
    });
    target.replaceChildren.apply(target, nodes);
  }

  function patchShopComponent() {
    if (!window.customElements) return;
    customElements.whenDefined('shop-component').then(function () {
      var Cls = customElements.get('shop-component');
      if (!Cls || !Cls.prototype || Cls.prototype.__elcoPatched) return;
      var proto = Cls.prototype;

      proto.getFromUrl = function (url) {
        var self = this;
        self.__elcoLatestUrl = url;

        // Aceeasi adresa ceruta de mai multe functii -> o singura cerere.
        if (self.__elcoReq && self.__elcoReq.url === url) return self.__elcoReq.promise;

        // Alt filtru bifat intre timp -> anulam cererea veche.
        if (self.__elcoReq && self.__elcoReq.controller) {
          try { self.__elcoReq.controller.abort(); } catch (e) {}
        }

        var controller = ('AbortController' in window) ? new AbortController() : null;
        var preloader = self.querySelector('#ShopProductsOverlay');
        if (preloader) preloader.classList.remove('hidden');

        var sectionId = shopSectionId(self);
        var full = toAbsUrl(url);
        full.searchParams.delete('section_id');
        var fullUrl = full.pathname + full.search;
        var sectionUrl = null;
        if (sectionId) {
          var su = toAbsUrl(fullUrl);
          su.searchParams.set('section_id', sectionId);
          sectionUrl = su.pathname + su.search;
        }

        var opts = { credentials: 'same-origin' };
        if (controller) opts.signal = controller.signal;

        function get(u) {
          return fetch(u, opts).then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.text();
          }).then(parseDoc);
        }

        var promise = (sectionUrl ? get(sectionUrl) : get(fullUrl)).then(function (doc) {
          if (doc.getElementById('ShopProducts') || !sectionUrl) return doc;
          return get(fullUrl);
        }).then(function (doc) {
          return self.__elcoLatestUrl === url ? doc : null; // raspuns depasit
        }, function (err) {
          if (!err || err.name !== 'AbortError') console.warn('[elco-filters]', err);
          return null;
        }).then(function (doc) {
          if (self.__elcoReq && self.__elcoReq.url === url) self.__elcoReq = null;
          if (preloader && self.__elcoLatestUrl === url) preloader.classList.add('hidden');
          return doc;
        });

        self.__elcoReq = { url: url, promise: promise, controller: controller };
        return promise;
      };

      proto.updateShop = function (url) {
        this.getFromUrl(url).then(function (html) {
          if (!html) return;
          SHOP_ELEMENTS.forEach(function (id) {
            var el = document.getElementById(id);
            var fresh = html.getElementById(id);
            if (!el || !fresh) return;
            if (id === 'ShopProducts') {
              moveChildren(el, fresh); // fara copie dubla in memorie
            } else {
              el.replaceChildren.apply(el, Array.prototype.slice.call(fresh.cloneNode(true).childNodes));
            }
          });
        });
      };

      proto.updateFilters = function (url) {
        var self = this;
        var filters = Array.prototype.slice.call(document.querySelectorAll(FILTER_SIDEBARS));
        filters.forEach(function (f) {
          try { if (f.preloader) f.preloader.classList.remove('hidden'); } catch (e) {}
        });
        self.getFromUrl(url).then(function (html) {
          filters.forEach(function (f) {
            if (html) {
              try { f.updateHTML(html); } catch (e) { console.warn('[elco-filters]', e); }
            }
            if (html || self.__elcoLatestUrl === url) {
              try { if (f.preloader) f.preloader.classList.add('hidden'); } catch (e) {}
            }
          });
          if (html) self.emit('filtersUpdated', {});
        });
      };

      proto.__elcoPatched = true;
    });
  }

  /* ------------------------------------------------------- protectie crash */
  // Daca o restaurare a fost intrerupta de un crash (iOS reincarca pagina),
  // nu o mai repetam - altfel intram in bucla "refresh -> crash".
  var RESTORE_FLAG = 'elcoLM:restoring';

  function previousRestoreCrashed(key) {
    try {
      var raw = sessionStorage.getItem(RESTORE_FLAG);
      if (!raw) return false;
      var f = JSON.parse(raw);
      return f && f.key === key && Date.now() - f.t < 3 * 60 * 1000;
    } catch (e) {
      return false;
    }
  }

  function markRestoring(key) {
    try { sessionStorage.setItem(RESTORE_FLAG, JSON.stringify({ key: key, t: Date.now() })); } catch (e) {}
  }

  function clearRestoring() {
    try { sessionStorage.removeItem(RESTORE_FLAG); } catch (e) {}
  }

  function dropState(key) {
    memoryState = null;
    try { sessionStorage.removeItem(SS_PREFIX + key); } catch (e) {}
    try {
      if (history.state && history.state[STATE_KEY]) {
        var copy = Object.assign({}, history.state);
        delete copy[STATE_KEY];
        history.replaceState(copy, '');
      }
    } catch (e) {}
    try { if ('scrollRestoration' in history) history.scrollRestoration = 'auto'; } catch (e) {}
  }

  /* ----------------------------------------------------------------- init */

  function init() {
    patchLoadButton();
    try { patchShopComponent(); } catch (e) { console.warn('[elco-filters] patch', e); }
    try { initMemoryManager(); } catch (e) { console.warn('[elco-load-more] memory manager', e); }

    var anyBtn = document.querySelector('pagination-load-button');
    var ctx = anyBtn ? getContext(anyBtn) : null;
    if (!ctx) {
      // Nu exista (inca) buton - poate e ultima pagina; tot incercam pozitia.
      var compOnly = document.querySelector('pagination-component[data-container-id]');
      ctx = compOnly ? getContext(compOnly) : null;
      if (!ctx) return;
    }

    ['touchstart', 'wheel', 'keydown', 'mousedown'].forEach(function (evt) {
      window.addEventListener(evt, function () { userInteracted = true; }, { passive: true, once: true });
    });

    trackAnchor(ctx);

    var st = readState();
    if (st) {
      if (previousRestoreCrashed(st.key)) {
        // Ultima restaurare nu s-a terminat (pagina a cazut) - pornim curat.
        clearRestoring();
        dropState(st.key);
        return;
      }
      setManualScrollRestoration();
      memoryState = st;
      markRestoring(st.key);
      restore(ctx, st).then(function () {
        // Consideram restaurarea reusita daca pagina mai traieste 8 secunde.
        setTimeout(clearRestoring, 8000);
      });
    }
  }

  // Pagina restaurata din bfcache: DOM-ul si scroll-ul sunt deja intacte.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) userInteracted = false;
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
